import { api } from "./api";
const endpoint = "volontariat/DomaineCompetence";

export const DomaineService = {
  async lister(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(filtre) {
    try {
      const result = await api.post(endpoint + "/insert", { ...filtre, k : "AX009XWKLMO450SHJEKAZEI" });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(filtre) {
    try {
      const result = await api.post(endpoint + "/update", { ...filtre, k : "AX009XWKLMO450SHJEKAZEI" });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(filtre) {
    try {
      const result = await api.delete(endpoint + "/delete", filtre);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { filtre: filtre },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
